import React, { useState, useEffect } from 'react';
import '../../css/brigade-form.css';

const BrigadeForm = ({ onSubmit, brigade, onCancel }) => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [fechaEstimadaFin, setFechaEstimadaFin] = useState('');
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (brigade) {
            setName(brigade.name || '');
            setDescription(brigade.description || '');
            setFechaEstimadaFin(brigade.fechaEstimadaFin ? brigade.fechaEstimadaFin.split('T')[0] : '');
        } else {
            setName('');
            setDescription('');
            setFechaEstimadaFin('');
        }
        setErrors({});
    }, [brigade]);

    const validateForm = () => {
        const newErrors = {};
        
        if (!name.trim()) {
            newErrors.name = 'El nombre es requerido';
        } else if (name.trim().length < 3) {
            newErrors.name = 'El nombre debe tener al menos 3 caracteres';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (!validateForm()) {
            return;
        }

        const data = { name: name.trim(), description: description.trim() };
        if (fechaEstimadaFin) data.fechaEstimadaFin = fechaEstimadaFin;
        onSubmit(data);

        if (!brigade) {
            setName('');
            setDescription('');
            setFechaEstimadaFin('');
        }
    };

    const handleCancel = () => {
        setName('');
        setDescription('');
        setErrors({});
        if (onCancel) {
            onCancel();
        }
    };

    return (
        <div className="brigade-form-container">
            <div className="brigade-form-header">
                <div className="form-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                        <circle cx="9" cy="7" r="4"/>
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                    </svg>
                </div>
                <h3 className="form-title">
                    {brigade ? 'Editar Brigada' : 'Nueva Brigada'}
                </h3>
            </div>

            <form onSubmit={handleSubmit} className="brigade-form">
                <div className="form-content">
                    <div className={`form-group ${errors.name ? 'has-error' : ''}`}>
                        <label htmlFor="brigade-name" className="form-label">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                                <circle cx="12" cy="7" r="4"/>
                            </svg>
                            Nombre de la Brigada
                            <span className="required">*</span>
                        </label>
                        <input
                            id="brigade-name"
                            type="text"
                            placeholder="Ej: Brigada Norte"
                            value={name}
                            onChange={(e) => {
                                setName(e.target.value);
                                if (errors.name) {
                                    setErrors({ ...errors, name: null });
                                }
                            }}
                            className={`brigade-input ${errors.name ? 'input-error' : ''}`}
                            maxLength={50}
                        />
                        {errors.name && (
                            <span className="error-message">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="10"/>
                                    <line x1="12" y1="8" x2="12" y2="12"/>
                                    <line x1="12" y1="16" x2="12.01" y2="16"/>
                                </svg>
                                {errors.name}
                            </span>
                        )}
                        <div className="input-hint">
                            {name.length}/50 caracteres
                        </div>
                    </div>
                    
                    <div className="form-group">
                        <label htmlFor="brigade-description" className="form-label">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                                <polyline points="14 2 14 8 20 8"/>
                                <line x1="16" y1="13" x2="8" y2="13"/>
                                <line x1="16" y1="17" x2="8" y2="17"/>
                                <polyline points="10 9 9 9 8 9"/>
                            </svg>
                            Descripción
                            <span className="optional">(Opcional)</span>
                        </label>
                        <textarea
                            id="brigade-description"
                            placeholder="Describe las responsabilidades y características de esta brigada..."
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            className="brigade-textarea"
                            rows="4"
                            maxLength={200}
                        />
                        <div className="input-hint">
                            {description.length}/200 caracteres
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="brigade-fecha-fin" className="form-label">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                                <line x1="16" y1="2" x2="16" y2="6"/>
                                <line x1="8" y1="2" x2="8" y2="6"/>
                                <line x1="3" y1="10" x2="21" y2="10"/>
                            </svg>
                            Fecha estimada de fin
                            <span className="optional">(Opcional)</span>
                        </label>
                        <input
                            id="brigade-fecha-fin"
                            type="date"
                            value={fechaEstimadaFin}
                            onChange={(e) => setFechaEstimadaFin(e.target.value)}
                            className="brigade-input"
                        />
                    </div>
                </div>
                
                <div className="form-actions">
                    <button type="submit" className="brigade-button save-button">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
                            <polyline points="17 21 17 13 7 13 7 21"/>
                            <polyline points="7 3 7 8 15 8"/>
                        </svg>
                        {brigade ? 'Actualizar' : 'Guardar'} Brigada
                    </button>
                    <button type="button" onClick={handleCancel} className="brigade-button cancel-button">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <line x1="18" y1="6" x2="6" y2="18"/>
                            <line x1="6" y1="6" x2="18" y2="18"/>
                        </svg>
                        Cancelar
                    </button>
                </div>
            </form>
        </div>
    );
};

export default BrigadeForm;